import { ProgCss } from "../ProgCss.Generated";
import { CalloutType, createAndAppendCallout, createAndShowAlert, createAndShowConfirm } from "../app";
import { castOrNull, cast, AssertNotNull } from "../tools";
import { vertaal } from "../vertaal";

export function registerPro6WorkflowListeners(scopeEl: HTMLElement) {
    const wfResetAlleStappen = castOrNull(scopeEl.querySelector("#wfResetAlleStappen"), HTMLButtonElement);
    wfResetAlleStappen?.addEventListener("click",
        (evt: MouseEvent) => {
            evt.preventDefault();
            createAndShowConfirm(
                vertaal("Opmerking", "Notice"),
                vertaal('Weet u het zeker? Alle stappen zullen gereset worden!', 'Are you sure? All steps will be reset!'),
                () => {
                    AssertNotNull(wfResetAlleStappen.form).requestSubmit(wfResetAlleStappen);
                },
            );
        });

    const wfAfmeldenProces = castOrNull(scopeEl.querySelector("#wfAfmeldenProces"), HTMLButtonElement);
    wfAfmeldenProces?.addEventListener("click",
        (evt) => {
            evt.preventDefault();
            createAndShowConfirm(
                vertaal("Opmerking", "Notice"),
                vertaal('Weet u zeker dat u zich voor dit proces wilt afmelden?', 'Are you sure you want to unsubscribe to this process?'),
                () => {
                    AssertNotNull(wfAfmeldenProces.form).requestSubmit(wfAfmeldenProces);
                },
            );
        });

    for (const wfResetStapElem of scopeEl.querySelectorAll(`.${ProgCss.js_wfResetStap}`)) {
        const wfResetStap = cast(wfResetStapElem, HTMLButtonElement);
        wfResetStap.addEventListener("click",
            (evt) => {
                evt.preventDefault();
                createAndShowConfirm(
                    vertaal("Opmerking", "Notice"),
                    vertaal('Weet u zeker dat u deze stap wilt resetten?', 'Are you sure?'),
                    () => {
                        if (wfResetStap.form) {
                            wfResetStap.form.stap.value = wfResetStap.getAttribute("data-stapid");
                            AssertNotNull(wfResetStap.form).requestSubmit(wfResetStap);
                        }
                    },
                );
            })
    }

    const wfLegvast = castOrNull(scopeEl.querySelector("#wfLegvast"), HTMLButtonElement);
    wfLegvast?.addEventListener("click",
        (e) => {
            e.preventDefault();

            const wfVastLegDataPlaceholder = castOrNull(scopeEl.querySelector("#wfVastLegDataPlaceholder"), HTMLSpanElement);
            if (wfVastLegDataPlaceholder) {
                const verantwoordingvakkenlijst = wfVastLegDataPlaceholder.getAttribute("data-vvl");
                const aanvraagpkid = wfVastLegDataPlaceholder.getAttribute("data-apkid");
                const minECTSString = wfLegvast.getAttribute("data-melding");
                if (minECTSString) {
                    createAndShowAlert(vertaal("Fout", "Error"), minECTSString, () => false);
                }
                else {
                    if (verantwoordingvakkenlijst == "1") {
                        createAndShowConfirm(
                            vertaal("Opmerking", "Notice"),
                            vertaal('Weet u het zeker? U kunt de vakkenlijst daarna niet meer aanpassen.', 'Are you sure? You cannot change the list after it has been presented.'),
                            () => {
                                castOrNull(scopeEl.querySelector("#wfMaakdefinitief"), HTMLFormElement)?.requestSubmit();
                            },
                        );
                    }
                    else if (verantwoordingvakkenlijst == "2" || verantwoordingvakkenlijst == "3") {
                        const wfproces = castOrNull(scopeEl.querySelector("#wfproces"), HTMLFormElement);
                        const mode = verantwoordingvakkenlijst == "2" ? 'optioneel' : 'verplicht';
                        const item = AssertNotNull(wfVastLegDataPlaceholder.getAttribute("data-item"));

                        if (wfproces) {
                            wfproces.mode.value = mode;
                            wfproces.item.value = item;
                            wfproces.aanvraag.value = aanvraagpkid;
                            wfproces.taak.value = 'verantwoordingvakkenlijst';
                            wfproces.requestSubmit();
                        }
                    }
                }
            }
        });

    const wfKnopbewaarToelichting = castOrNull(scopeEl.querySelector("#wfKnopbewaarToelichting"), HTMLButtonElement);
    wfKnopbewaarToelichting?.addEventListener("click",
        (e) => {
            const wfToevoegDataPlaceholder = castOrNull(scopeEl.querySelector("#wfToevoegDataPlaceholder"), HTMLSpanElement);
            if (wfToevoegDataPlaceholder) {
                const mode = wfToevoegDataPlaceholder.getAttribute("data-mode");
                const item = wfToevoegDataPlaceholder.getAttribute("data-item");
                const aanvraagpkid = wfToevoegDataPlaceholder.getAttribute("data-apkid");

                const wfToevoegenToelichtingForm = castOrNull(scopeEl.querySelector("#wfToevoegenToelichting"), HTMLFormElement);
                if (wfToevoegenToelichtingForm) {
                    if (mode == 'verplicht' && wfToevoegenToelichtingForm.opmerking.value.trim() == '') {
                        createAndAppendCallout(vertaal('U dient een toelichting te geven!', 'You must add a commentary'), CalloutType.Danger);
                    } else {
                        wfToevoegenToelichtingForm.item.value = item;
                        wfToevoegenToelichtingForm.taak.value = 'verantwoordingvakkenlijst';
                        wfToevoegenToelichtingForm.mode.value = 'voegtoe';
                        wfToevoegenToelichtingForm.actie.value = 'bewaar';
                        wfToevoegenToelichtingForm.aanvraag.value = aanvraagpkid;
                        wfToevoegenToelichtingForm.requestSubmit();
                    }
                }
            }
        });

    for (const wfVakVoegtoe of scopeEl.querySelectorAll(`.${ProgCss.js_wfVakVoegtoe}`)) {
        wfVakVoegtoe.addEventListener("click",
            (e) => {
                const wfClForm = cast(scopeEl.querySelector("#wfClForm"), HTMLFormElement);

                const source = cast(e.currentTarget, HTMLButtonElement);
                wfClForm.categorie.value = source.getAttribute("data-vcid");
                wfClForm.knop.value = 'voegtoe';
                wfClForm.requestSubmit();
            });
    }

    const knopHaalVanLijst = castOrNull(scopeEl.querySelector("#knophaalvanlijst"), HTMLButtonElement);

    knopHaalVanLijst?.addEventListener("click",
        () => {
            const wfClForm = cast(scopeEl.querySelector("#wfClForm"), HTMLFormElement);
            wfClForm.knop.value = 'verwijder';
            wfClForm.requestSubmit();
        })

    const knopzetoplijst = castOrNull(scopeEl.querySelector("#knopzetoplijst"), HTMLButtonElement);
    knopzetoplijst?.addEventListener("click",
        () => {
            const wfClForm = cast(scopeEl.querySelector("#wfClForm"), HTMLFormElement);
            wfClForm.knop.value = 'voegtoe';
            wfClForm.requestSubmit();
        })

    for (const wfSortButton of scopeEl.querySelectorAll(`.${ProgCss.js_wf_st_sort_buttons}`)) {
        wfSortButton.addEventListener("click",
            (e) => {
                const wfClForm = cast(scopeEl.querySelector("#wfClForm"), HTMLFormElement);

                const source = cast(e.currentTarget, HTMLButtonElement);
                const volgordeField = cast(scopeEl.querySelector("#wfVolgorde" + source.getAttribute("data-sort-tabel")), HTMLInputElement);
                volgordeField.value = source.getAttribute("data-sort-volgorde")!;
                const sorteerField = cast(scopeEl.querySelector("#wfSorteer" + source.getAttribute("data-sort-tabel")), HTMLInputElement);
                sorteerField.value = source.getAttribute("data-sort-kolom")!;

                wfClForm.requestSubmit();
            });
    }
    
    
    const wfMaakStapBericht = castOrNull(scopeEl.querySelector("#wfMaakStapBericht"), HTMLTextAreaElement);
    if (wfMaakStapBericht) {
        for (const event of ["keyup", "mouseout", "focus", "click"]) {
            wfMaakStapBericht.addEventListener(event, () => MaakStapAantalCharMelding());
        }
    }
    let berichtElement: HTMLTextAreaElement;
    let berichtLengteMeldingDiv: HTMLDivElement;

    const wfMaakStapBerichtForm = castOrNull(scopeEl.querySelector("#wfMaakStapBerichtForm"), HTMLFormElement);
    wfMaakStapBerichtForm?.addEventListener("submit",
        (e) => {
            if (wfMaakStapBerichtForm!.reportValidity() == false || MaakStapTelChar(wfMaakStapBerichtForm!.rbericht) == false) {
                e.preventDefault();
            }
        });


    const giMaxBerichtLengte = wfMaakStapBerichtForm ? +wfMaakStapBerichtForm.getAttribute("data-imaxmssgsize")! : 0;

    function MaakStapTelChar(berichtVeld: HTMLTextAreaElement) {
        if (berichtVeld.value.length > giMaxBerichtLengte) {
            alert("De lengte van het bericht is " + berichtVeld.value.length
                + " karakters.\n Dat is langer dan " + giMaxBerichtLengte + " karakters, "
                + "de maximum lengte.\n Kort uw bericht in.");
            return false
        }
        else {
            return true
        }
    }


    function MaakStapAantalCharMelding() {
        !berichtElement ? berichtElement = wfMaakStapBericht! : void (0);

        const lengte = berichtElement.value.length;
        !berichtLengteMeldingDiv ? berichtLengteMeldingDiv = cast(scopeEl.querySelector("#berichtlengte"), HTMLDivElement) : void (0);

        berichtLengteMeldingDiv.innerHTML = 'uw bericht bevat nu ' + lengte + ' teken' + (lengte == 1 ? '. ' : 's. ');
        if (giMaxBerichtLengte - lengte < 0) {
            const echteButton = document.createElement('input');
            echteButton.type = "button";
            echteButton.value = "breek af";
            echteButton.onclick = () => {
                berichtElement.value = berichtElement.value.substring(0, giMaxBerichtLengte);
                berichtElement.scrollTop = berichtElement.scrollHeight;
                MaakStapAantalCharMelding();
            };
            berichtLengteMeldingDiv.appendChild(echteButton);
            berichtLengteMeldingDiv.insertAdjacentHTML('beforeend', '<div style="font-weight:600;color:red;background:#FFFFC0;' +
                'border:1px solid red;padding:1px 2px  1px 2px;text-align:center">' +
                'Let op: alleen de eerste ' + giMaxBerichtLengte + ' tekens van uw bericht zullen worden verstuurd!</div>');
        } else if (giMaxBerichtLengte - lengte == 0) {
            berichtLengteMeldingDiv.innerHTML += 'U heeft de maximale lengte van uw bericht bereikt';
        } else {
            berichtLengteMeldingDiv.innerHTML += 'U kunt nog ' +
                (giMaxBerichtLengte - lengte) +
                (giMaxBerichtLengte - lengte == 1 ? ' teken' : ' tekens') +
                ' typen';
        }
    }

    const wfWizardForm = castOrNull(scopeEl.querySelector("#wfWizardForm"), HTMLFormElement);
    wfWizardForm?.addEventListener("submit",
        (e) => {
            if (!check_processtap(wfWizardForm!)) {
                e.preventDefault();
            }
        });

    function check_processtap(wfWizardForm: HTMLFormElement) {
        const radiolen = wfWizardForm.processtap.length || 1;

        if (radiolen === 1) {
            wfWizardForm.processtap.checked = true;
            return true;
        }
        else {
            for (const stap of wfWizardForm.processtap) {
                if (stap.checked) {
                    return true;
                }
            }
        }

        alert("Selecteer processtap.");
        return false;
    }
}
